import { InputUsuario, Modal, TableCustom } from "../../common"
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToString } from "../../../utils/convert"
import { useEffect, useState } from "react"
import { useLista } from "../../hooks"
import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';
import { CloneObject } from "../../../utils/helpers"


const movimientoInit = {
    id: 0,
    idCaja: 0,
    idCajaAsignacion: 0,
    idTipoMovimientoCaja: 0,
    importeCobro: 0,
    fechaCobro: null,
    observacion: "",
    mediosPagos: [],
    recibos: []
}

const MovimientosCajaDetalleModal = ({ movimiento, onCancel }) => {

    const [detalle, setDetalle] = useState(movimientoInit)
    const [accordions, setAccordions] = useState({
        veps: true,
        mediosPago: true,
        anulacion: true
    })

    useEffect(() => {
        if (movimiento) {
            setDetalle(movimiento)
        }
    }, [movimiento])

    const [, getRowLista ] = useLista({
        listas: ['TipoMovimientoCaja','MedioPago'],
        onLoaded: (_, isSuccess, error) => {
          if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: {
          key: 'TipoMovimientoCaja_MedioPago',
          timeout: 0
        }
    })

    function ToggleAccordion(accordion) {
        let accordions2 = CloneObject(accordions);
        accordions2[accordion] = !accordions2[accordion];
        setAccordions(accordions2);
    }

    const accordionClose = <span className="material-symbols-outlined search-i">chevron_right</span>
    const accordionOpen = <span className="material-symbols-outlined search-i">expand_more</span>

    return (
        <Modal
            onEscape={onCancel}
            size="xl"
            title="Detalle de movimiento"
            body={(
            <>

                <div className='accordion-header m-top-10'>
                    <div className='row'>
                        <div className="col-12" onClick={() => ToggleAccordion('veps')}>
                            <div className='accordion-header-title'>
                                {(accordions.veps) ? accordionOpen : accordionClose}
                                <h3 className={accordions.veps ? 'active' : ''}>VEPs</h3>
                            </div>
                        </div>
                    </div>
                </div>
                {accordions.veps && (
                <div className='accordion-body'>
                    <TableCustom
                        className={'TableCustomBase m-top-5'}
                        data={detalle.recibos}
                        columns={[
                            { Header: 'Cuenta', accessor: 'numeroCuenta', width: '15%' },
                            { Header: 'Número', Cell: ({ row }) => getNumeroRecibo_ObjectToString(row.original), accessor: 'numeroRecibo', width: '15%' },
                            { Header: 'Periodo', accessor: 'periodo', width: '7%' },
                            { Header: 'Cuota', accessor: 'cuota', width: '7%' },
                            { Header: 'Fecha 1° Vto.', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaVencimiento1', width: '13%' },
                            { Header: 'Imp. 1° Vto.', Cell: (data) => getFormatNumber(data.value, 2), accessor: 'importeVencimiento1', width: '13%', alignCell: 'right' },
                            { Header: 'Fecha 2° Vto.', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaVencimiento2', width: '13%' },
                            { Header: 'Imp. 2° Vto.', Cell: (data) => getFormatNumber(data.value, 2), accessor: 'importeVencimiento2', width: '13%', alignCell: 'right' },
                        ]}
                        showDownloadCSV={false}
                        showFilterGlobal={false}
                    />
                </div>
                )}

                <div className='accordion-header m-top-10'>
                    <div className='row'>
                        <div className="col-12" onClick={() => ToggleAccordion('mediosPago')}>
                            <div className='accordion-header-title'>
                                {(accordions.mediosPago) ? accordionOpen : accordionClose}
                                <h3 className={accordions.mediosPago ? 'active' : ''}>Medios de pago</h3>
                            </div>
                        </div>
                    </div>
                </div>
                {accordions.mediosPago && (
                <div className='accordion-body'>
                    <TableCustom
                        className={'TableCustomBase m-top-5 m-bottom-20'}
                        data={detalle.mediosPagos}
                        columns={[
                            { Header: 'Medio de pago', accessor: 'idMedioPago', width: '30%', Cell: ({ value }) => getRowLista('MedioPago', value)?.nombre ?? '' },
                            { Header: 'Entidad', accessor: 'bancoMedioPago', width: '25%' },
                            { Header: 'Número', accessor: 'numeroMedioPago', width: '25%' },
                            { Header: 'Importe de pago', Cell: (data) => getFormatNumber(data.value, 2), accessor: 'importeCobro', width: '20%', alignCell: 'right' }
                        ]}
                        showDownloadCSV={false}
                        showFilterGlobal={false}
                    />
                </div>
                )}

                {detalle.anulado && (
                <>
                    <div className='accordion-header m-top-10'>
                        <div className='row'>
                            <div className="col-12" onClick={() => ToggleAccordion('anulacion')}>
                                <div className='accordion-header-title'>
                                    {(accordions.anulacion) ? accordionOpen : accordionClose}
                                    <h3 className={accordions.anulacion ? 'active' : ''}>Anulación</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='accordion-body' style={{ display: accordions.anulacion ? 'block' : 'none' }}>
                        <div className="row form-basic m-top-5 m-bottom-20">
                            <div className="col-12 col-lg-4">
                                <label htmlFor="fechaAnulacion" className="form-label">Fecha de anulación</label>
                                <input
                                    name="fechaAnulacion"
                                    className="form-control"
                                    value={getDateToString(detalle.fechaAnulacion, true)}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-12 col-lg-8">
                                <label htmlFor="idUsuarioAnulacion" className="form-label">Usuario</label>
                                <InputUsuario
                                    name="idUsuarioAnulacion"
                                    className="form-control"
                                    value={detalle.idUsuarioAnulacion}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-12 m-top-10">
                                <label htmlFor="observacionAnulacion" className="form-label">Observaciones</label>
                                <textarea
                                    name="observacionAnulacion"
                                    className="form-control"
                                    rows={2}
                                    value={detalle.observacionAnulacion || ''}
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </div>
                </>
                )}

            </>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                </div>
            )}
        />
    )
}

export default MovimientosCajaDetalleModal
